import { apiClient, PostPlaidLinkTokenResponseData } from '@melio/javascript-sdk';

import { useModelApi, UseModelApiProps } from '../../core';
import { PlaidLinkTokenModel } from './types';

export const usePlaidLinkToken = (
  props: UseModelApiProps<PostPlaidLinkTokenResponseData> = {}
): PlaidLinkTokenModel => {
  const client = apiClient.plaidLinkTokens();

  const query = useModelApi<PostPlaidLinkTokenResponseData>({
    ...props,
    id: 'my-token-id', // trick the system to fetch without an actual id
    queryKey: 'plaid-link-token',
    queryFn: client.create,
  });

  return query;
};
